import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const diagnosticMessages = [
  "INITIALIZING QUANTUM COHERENCE SCAN...",
  "CHECKING TIMELINE STABILITY...",
  "ANALYZING PROBABILITY MATRICES...",
  "SCANNING FOR PARADOX ANOMALIES...",
  "VALIDATING CAUSALITY CHAINS...",
  "MEASURING ENTROPY LEVELS...",
  "CALIBRATING REALITY ANCHORS...",
  "OPTIMIZING SIMULATION PARAMETERS...",
  "REALITY DEBUG COMPLETE"
];

const DebugRealityModal = ({ isOpen, onClose }) => {
  const [currentMessage, setCurrentMessage] = useState(0);
  const [showComplete, setShowComplete] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setCurrentMessage(0);
      setShowComplete(false);
      return;
    }

    const interval = setInterval(() => {
      if (currentMessage < diagnosticMessages.length - 1) {
        setCurrentMessage(prev => prev + 1);
      } else {
        setShowComplete(true);
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isOpen, currentMessage]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
      />
      
      <motion.div 
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        className="relative bg-purple-950/90 border-2 border-[#39ff14] p-8 rounded-lg w-full max-w-2xl mx-4"
      >
        <div className="absolute inset-0 overflow-hidden rounded-lg">
          <div className="debug-scan-effect"></div>
        </div>

        <div className="relative z-10">
          <h2 className="text-[#39ff14] text-2xl mb-6 font-['VT323'] glitch-text">
            DEBUG_REALITY.exe
          </h2>

          <div className="space-y-4 font-mono">
            <AnimatePresence mode="wait">
              {diagnosticMessages.slice(0, currentMessage + 1).map((message, index) => (
                <motion.div
                  key={message}
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: 0.1 * index }}
                  className="flex items-center space-x-2"
                >
                  <span className="text-[#39ff14]">&gt;</span>
                  <span className={`${index === currentMessage ? 'cyber-glitch-2' : ''} text-cyan-400`}>
                    {message}
                  </span>
                  {index === currentMessage && !showComplete && (
                    <span className="animate-pulse text-[#39ff14]">_</span>
                  )}
                </motion.div>
              ))}
            </AnimatePresence>

            {showComplete && (
              <motion.button
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="mt-6 crt-button bg-transparent text-[#39ff14] border-2 border-[#39ff14] px-6 py-2 hover:bg-[#39ff14]/10"
                onClick={onClose}
              >
                CLOSE_DEBUG_SESSION
              </motion.button>
            )}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default DebugRealityModal;
